import React, { useEffect, useContext, useState } from "react";
import { Fragment } from "react";
import {
  DotsVerticalIcon,
  ChatAltIcon,
  SearchIcon,
  ArrowLeftIcon, // Added
} from "@heroicons/react/solid";
import { socket, SocketContext } from "../services.js/socket";
import backendService from "../services.js/backendService";
import { Menu, Transition } from "@headlessui/react";
import SearchMessageModal from "./SearchMessageModal";
import GroupSettingsModal from "./GroupSettingsModal";
import ConfirmationDeleteConversation from "./ConfirmationDeleteConversation";
import axios from "axios";
import ReactTooltip from "react-tooltip";

const optimizeURL = (URL) => {
  const parametre = "upload/q_auto:best";
  return URL.replace("upload", parametre);
};

//create function classNames
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

//create function chatHeader
function ChatHeader(props) {
  const socket = useContext(SocketContext);
  const [showSearchMessageModal, setShowSearchMessageModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [usersOnline, setUsersOnline] = useState([]);
  const [deleteConversationState, setDeleteConversationState] = useState(false);
  const [notification, setNotification] = useState(
    props.userInfo.notificationState.length > 0
      ? props.userInfo.notificationState[0].status
      : true
  );
  useEffect(() => {
    setNotification(
      props.userInfo.notificationState.length > 0
        ? props.userInfo.notificationState[0].status
        : true
    );
  }, [props.userInfo]);

  const setNotificationState = async (state) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/setnotificationstate`,
        {
          conversationId: props.userInfo._id,
          status: state,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );

      setNotification(state);
      props.clicked(new Date());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    socket.emit("addUser", {
      userId: backendService.getLoggedInUser()._id,
    });
    socket.on("userAdded", (data) => {
      setUsersOnline(data);
    });
  }, [socket]);

  return (
    <>
      {showSearchMessageModal && (
        <SearchMessageModal
          ShowSearchMessageModal={setShowSearchMessageModal}
          userInfo={props.userInfo}
        />
      )}
      {showSettingsModal && (
        <GroupSettingsModal
          ShowSettingsModal={setShowSettingsModal}
          userInfo={props.userInfo}
          clicked={props.clicked}
          refresh={props.refresh}
        />
      )}

      {deleteConversationState && (
        <ConfirmationDeleteConversation
          openDeleteConvoAlert={setDeleteConversationState}
          id={props.userInfo._id}
        />
      )}
      <div className=" bg-palette_color2  shadow flex items-center px-5 sticky top-0 z-10">
        <ReactTooltip delayShow={500} delayHide={100} />
        <div className="flex justify-between h-[60px] items-center  w-full">
          {/* Back Button - Mobile Only */}
          {props.onBackButtonClick && (
            <button
                onClick={props.onBackButtonClick}
                className="p-2 rounded-md text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 md:hidden mr-2"
            >
                <ArrowLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          )}
          <div className="flex items-center font-robo flex-grow min-w-0 px-2 ">
            {!props.userInfo.groupName
              ? chatrowHeader(usersOnline, props)
              : groupHeader(props)}
          </div>
          <div className="flex items-center">
            {searchIconHeader(setShowSearchMessageModal)}
            {threeDotMenuHeader(
              notification,
              setNotificationState,
              props,
              setShowSettingsModal,
              setDeleteConversationState
            )}
          </div>
        </div>
      </div>
    </>
  );
}
//export ChatHeader
export default ChatHeader;
function threeDotMenuHeader(
  notification,
  setNotificationState,
  props,
  setShowSettingsModal,
  setDeleteConversationState
) {
  return (
    <Menu as="div" className="relative inline-block text-left z-10 ">
      <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
        <Menu.Button>
          <DotsVerticalIcon
            data-tip="Options"
            data-place="left"
            className="h-5 w-5 "
          />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute right-0 mt-1 w-56 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none">
          <Menu.Item>
            {({ active }) => (
              <a
                href="#"
                className={classNames(
                  active
                    ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                    : "text-palette_color1",
                  "block px-4 py-2 text-sm font-robo "
                )}
                onClick={(e) => {
                  e.preventDefault();
                  setNotificationState(!notification);
                  // navigate("/edit-profile");
                }}
              >
                {!notification
                  ? "Turn on notifications"
                  : "Turn off notifications"}
              </a>
            )}
          </Menu.Item>
          {props.userInfo.state === "grouped" && (
            <Menu.Item>
              {({ active }) => (
                <a
                  href="#"
                  className={classNames(
                    active
                      ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                      : "text-palette_color1",
                    "block px-4 py-2 text-sm font-robo "
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSettingsModal(true);
                    // navigate("/edit-profile");
                  }}
                >
                  {props.userInfo.groupAdmin.includes(
                    backendService.getLoggedInUser()._id
                  )
                    ? "Settings"
                    : "Group Details"}
                </a>
              )}
            </Menu.Item>
          )}
          {props.userInfo.state !== "grouped" && (
            <Menu.Item>
              {({ active }) => (
                <a
                  href="#"
                  className={classNames(
                    active
                      ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                      : "text-palette_color1",
                    "block px-4 py-2 text-sm font-robo "
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    setDeleteConversationState(true);
                    // navigate("/edit-profile");
                  }}
                >
                  Delete Conversation
                </a>
              )}
            </Menu.Item>
          )}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

function searchIconHeader(setShowSearchMessageModal) {
  return (
    <div
      className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full mr-2"
      data-tip="Search Messages"
      data-place="left"
    >
      <SearchIcon
        className="h-5 w-5 cursor-pointer"
        aria-hidden="true"
        onClick={() => setShowSearchMessageModal(true)}
      />
    </div>
  );
}

function groupHeader(props) {
  return (
    <>
      <div className="relative w-[40px] h-[40px]">
        <img
          alt="Profile"
          className="rounded-full h-[40px] w-[40px] cursor-pointer shadow-2xl"
          src={
            props.userInfo.profilePicture
              ? optimizeURL(props.userInfo.profilePicture.filePath)
              : require("../assets/people.png")
          }
        />
      </div>
      <div className="flex flex-col pl-2">
        <h3 className=" text-primary text-md font-robo ">
          {props.userInfo.groupName}
        </h3>
        {props.userInfo.groupDescription?.length > 0 && (
          <h3 className=" text-secondary text-xs font-robo">
            {props.userInfo.groupDescription}
          </h3>
        )}
        {/* <h3 className=" text-secondary text-md font-robo">
            {props.userInfo.participants
            .map((participant) => participant.firstname.split(" ")[0])
            .join(", ")}
          </h3> */}
      </div>
    </>
  );
}

function chatrowHeader(usersOnline, props) {
  return (
    <>
      <div
        className="relative w-[40px] h-[40px] "
        data-tip={
          usersOnline.find(
            (user) => user.userId === props.userInfo.participants[0]?._id
          )
            ? "Online"
            : "Offline"
        }
        data-place="bottom"
      >
        <img
          alt="Profile"
          className={classNames(
            usersOnline.find(
              (user) => user.userId === props.userInfo.participants[0]?._id
            )
              ? "outline-[#44ff00]"
              : "outline-gray-500",
            "rounded-full h-[40px] w-[40px] cursor-pointer outline-3 shadow-2xl outline outline-offset-2 "
          )}
          src={
            props.userInfo.participants[0]?.profilePicture &&
            props.userInfo.participants[0].profilePicture?.filePath !== null
              ? optimizeURL(
                  props.userInfo.participants[0].profilePicture.filePath
                )
              : require("../assets/boredApe.png")
          }
        />
      </div>
      <div className="inline-grid grid-rows-2 pl-2 ">
        <h3 className=" text-primary text-md font-robo pl-2 ">
          {props.userInfo.participants[0].firstname +
            " " +
            props.userInfo.participants[0].lastname}
        </h3>
        <h3 className=" text-secondary text-xs font-robo pl-2 ">
          {"@" + props.userInfo.participants[0].username}
        </h3>
      </div>
    </>
  );
}
